import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import styles from "./Profile.module.css";
import Input from "../../../../components/Input/Input";
import FileUpload from "../../../../components/FileUpload/FileUpload";
import ProfileCompletion from "../../../../components/ProfileCompletion/ProfileCompletion";
import TopLabelCustomSelectBox from "../../../../components/TopLabelReactSelect/TopLabelReactSelect";
import {
  GenderOptions,
  FindUsOptions,
  YearsExperience,
  membershipBenefitsInterested,
} from "../../../../utils/constants";
import EducationalQualification from "../../../../components/EducationAddMore/EducationAddMore";
import WorkshopsSeminars from "../../../../components/WorkShopsSeminars/WorkShopsSeminars";
import AcademicActivites from "../../../../components/AcademicActivites";
import { useAuth } from "../../../../context/AuthContext";
import ResearchProjects from "../../../../components/ResearchProjects";
import Textarea from "../../../../components/Textarea/Textarea";
import { API_ENDPOINTS } from "../../../../api/endpoints";
import apiClient from "../../../../api/apiClient";
import { toast } from "react-toastify";
import Loader from "../../../../components/Loader/Loader";
import WorkingExperience from "../../../../components/WorkingExperience/WorkingExperience";
import SocialMediaLinks from "../../../../components/SocialMediaLinks/SocialMediaLinks";
import AcademicLinks from "../../../../components/AcademicLinks/AcademicLinks";
import MentorshipSelect from "../../../../components/ResearchProjects/MentorshipSelect";
import { useCountries } from "../../../../hooks/useCountries";
import Achievements from "../../../../components/Achievements/Achievements";

const MembershipRegistration = ({ }) => {
  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    defaultValues: {
      educationalQualification: [
        { institutionName: "", degree: "", department: "", duration: "" },
      ],
      workingExperience: [
        { companyName: "", designation: "", description: "", duration: "" },
      ],
      achievements: [
        {
          title: "",
          type_of_achievement: "",
          awarding: "",
          recognizing_body: "",
          description: "",
          year: "",
        },
      ],
      researchPapers: [
        {
          title: "",
          journalName: "",
          authors: "",
          indexingCategory: "",
          year: "",
          DOI: "",
        },
      ],
      bookPublications: [{ bookTitle: "", publisher: "", year: "", ISBN: "" }],
      bookChapters: [
        {
          chapterTitle: "",
          bookTitle: "",
          year: "",
          DOI: "",
          publisher: "",
        },
      ],
      conferencePapers: [
        { title: "", conferenceName: "", year: "", organizer: "", indexed: "" },
      ],
      workshopSeminars: [{ title: "", organizer: "", category: "", year: "" }],
      experienceYears: 0,
      numberofMentees: 0,
    },
  });
  const [profileCompletion, setProfileCompletion] = useState(0);
  const [loading, setLoading] = useState(false);
  const [fileUploadedKey, setFileUploadedKey] = React.useState(Date.now());
  const { userdata } = useAuth();
  const [userProfile, setUserProfile] = useState({});
  const [stateList, setStateList] = useState([]);
  const [subjectExpertiseList, setSubjectExpertiseList] = useState([]);
  const [mentorshipOfferedList, setMentorshipOfferedList] = useState([]);
  const [isEditable, setIsEdiatble] = useState(false);
  const [departmentTypeList, setDepartmentTypeList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const { countries, loading: countriesLoading } = useCountries();

  useEffect(() => {
    fetchProfileData();
    fetchSubjectExpertise();
    fetchMentorshipOffered();
  }, []);

  const flattenExpertise = (data) => {
    const result = [];

    const traverseChildren = (nodes) => {
      nodes.forEach((node) => {
        // ✅ ADD CURRENT NODE
        result.push({
          label: node.name,
          value: node.id,
        });

        // ✅ THEN traverse children (if any)
        if (node.children && node.children.length > 0) {
          traverseChildren(node.children);
        }
      });
    };

    data.forEach((category) => {
      // Category heading (disabled)
      result.push({
        label: category.category,
        value: `cat-${category.category_id}`,
        isDisabled: true,
      });

      traverseChildren(category.items);
    });

    return result;
  };

  const subjectOptions = React.useMemo(
    () => flattenExpertise(subjectExpertiseList),
    [subjectExpertiseList]
  );

  useEffect(() => {
    if (!userProfile?.subjectStream) return;
    if (!subjectOptions.length) return;

    setValue("subjectStream", userProfile.subjectStream || "", {
      shouldValidate: false,
    });
  }, [subjectOptions, userProfile?.subjectStream]);

  const fetchProfileData = async () => {
    try {
      setLoading(true);
      const res = await apiClient({
        url: `${userdata.role === "mentor"
            ? API_ENDPOINTS.VIEW_MENTOR_PROFILE
            : userdata.role === "author"
              ? API_ENDPOINTS.VIEW_AUTHOR_PROFILE
              : null
          }/${userdata.id}`,
        method: "get",
        withAuth: true,
      });

      const profile = res?.data?.data;
      setUserProfile(profile);
      // Prefill form with data received from API

      reset({
        ...profile,
        subjectStream: profile.subjectStream ? profile.subjectStream : null,
        fullName: userdata.name,
        email: userdata.email,
        phone: userdata.contact_no,
        experienceYears: String(profile.experienceYears) || 0,
        numberofMentees: String(profile.numberofMentees) || 0,
        preferredMentorshipRole: profile.preferredMentorshipRole || [],
        preferredMentorshipRoleOther:
          profile.preferredMentorshipRoleOther || "",
      });
      setFileUploadedKey(Date.now());
    } catch (error) {
      console.error("Profile GET Error:", error);
      if (error.status === 404) {
        toast.warning("Profile is not created yet.");
      } else {
        toast.error(
          error?.response?.data?.message
            ? error.response.data.message
            : "Unable to load profile."
        );
      }
    }

    setLoading(false);
  };

  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      console.log("Changed Field:", name);
      console.log("New Form Value:", value);
    });

    return () => subscription.unsubscribe();
  }, [watch]);


  // Fetch states AFTER profile is loaded
  useEffect(() => {
    if (userProfile?.country) {
      fetchStates(userProfile.country);
    }
  }, [userProfile?.country]);

  const selectedCountry = watch("country");

  useEffect(() => {
    if (selectedCountry) {
      fetchStates(selectedCountry);
    }
  }, [selectedCountry]);

  const fetchStates = async (countryId) => {
    try {
      const res = await apiClient({
        url: `${API_ENDPOINTS.GET_STATES}/${countryId}/states`,
        method: "get",
        withAuth: true,
      });

      setStateList(
        res?.data?.states?.map((item) => ({
          label: item.name,
          value: item.iso2,
        }))
      );
    } catch (error) {
      console.error("State fetch error:", error);
    }
  };

  /** country state logic ends */

  const fetchSubjectExpertise = async () => {
    try {
      const res = await apiClient({
        url: API_ENDPOINTS.GET_SUBJECT_EXPERTISE,
        method: "get",
        withAuth: true,
      });
      setSubjectExpertiseList(res?.data?.data);
    } catch (error) {
      console.error("SUBJECT_EXPERTISE fetch error:", error);
    }
  };

  const fetchMentorshipOffered = async () => {
    try {
      const res = await apiClient({
        url: API_ENDPOINTS.GET_MENTORSHIP_OFFERED,
        method: "get",
        withAuth: true,
      });
      setMentorshipOfferedList(res?.data?.data);
    } catch (error) {
      console.error("GET_MENTORSHIP_OFFERED fetch error:", error);
    }
  };
  const onSubmit = async (data) => {
    if (!isEditable) return;
    setLoading(true);

    data.subjectMatterExpertise =
      data.subjectMatterExpertise &&
        typeof data.subjectMatterExpertise === "object"
        ? data.subjectMatterExpertise
        : {};

    data.mentorshipOffered =
      data.mentorshipOffered && typeof data.mentorshipOffered === "object"
        ? data.mentorshipOffered
        : {};

    const selectedDepartment = departmentTypeList.find(
      (dep) => dep.value === data.department
    );

    if (selectedDepartment) {
      data.department = selectedDepartment.key;
    }

    const formData = new FormData();

    // Fields you want to convert to JSON string
    const jsonFields = [
      "educationalQualification",
      "researchPapers",
      "bookPublications",
      "bookChapters",
      "conferencePapers",
      "workshopSeminars",
      "thesisSupervision",
      "dissertations",
      "fundedResearchProjects",
      "workingExperience",
      "achievements",
      "subjectMatterExpertise",
      "mentorshipOffered",
      "publishedProjects",
    ];

    Object.keys(data).forEach((key) => {
      // Convert specific fields to JSON
      if (jsonFields.includes(key)) {
        formData.append(key, JSON.stringify(data[key]));
      }
      // Append NON-FILE fields normally
      else if (!(data[key] instanceof FileList)) {
        formData.append(key, data[key]);
      }
    });

    // Append FILE fields
    Object.keys(data).forEach((key) => {
      if (data[key] instanceof FileList && data[key].length > 0) {
        formData.append(key, data[key][0]);
      }
    });

    formData.append("user_id", userdata.id);
    formData.append("profile_status", profileCompletion);

    // console.log([...formData], "FORMDATA PAYLOAD");

    try {
      const res = await apiClient({
        url:
          userdata.role === "mentor"
            ? API_ENDPOINTS.UPDATE_MENTOR_PROFILE
            : userdata.role === "author"
              ? API_ENDPOINTS.UPDATE_AUTHOR_PROFILE
              : null,
        method: "post",
        data: formData,
        withAuth: true,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success("Profile updated successfully!", {
        position: "top-center",
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
      });
      const profile = res?.data?.data || res?.data;
      const departmentOption = departmentTypeList.find(
        (dep) => dep.key === profile.department
      );

      const instTypeOption = departmentList.find(
        (type) => type.label === profile.institutionType
      );
      setUserProfile(profile);
      // Prefill form with data received from API

      reset({
        ...profile,
        department: departmentOption ? departmentOption.value : null,
        institutionType: instTypeOption ? instTypeOption.value : null,
        subjectStream: profile.subjectStream ? profile.subjectStream : null,
        fullName: userdata.name,
        email: userdata.email,
        phone: userdata.contact_no,
        experienceYears: String(profile.experienceYears) || 0,
        numberofMentees: String(profile.numberofMentees) || 0,
        preferredMentorshipRole: profile.preferredMentorshipRole || [],
        preferredMentorshipRoleOther:
          profile.preferredMentorshipRoleOther || "",
      });
      setFileUploadedKey(Date.now());
      setIsEdiatble(false);
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        "Failed to update profile. Please try again.";

      toast.error(message, {
        position: "top-center",
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
      });

      console.error("Upload Error:", error);
    }

    setLoading(false);
  };

  const published = watch("publishedResearch");

  useEffect(() => {
    if (published === "no") {
      setValue("researchPapers", []);
      setValue("bookPublications", []);
      setValue("bookChapters", []);
      setValue("conferencePapers", []);
    }
  }, [published, setValue]);

  const profileExcludeFields = React.useMemo(() => {
    if (userdata.role === "mentor") {
      return [
        "preferredMentorshipRole",
        "preferredMentorshipRoleOther",
        "subjectMatterExpertise",
        "mentorshipOffered",
      ];
    }

    if (userdata.role === "author") {
      return ["preferredMentorshipRole", "preferredMentorshipRoleOther"];
    }

    return [];
  }, [userdata.role]);

  const academicExclude =
    published === "no"
      ? [
        "researchPapers",
        "bookPublications",
        "bookChapters",
        "conferencePapers",
      ]
      : [];

  const finalExclude = [...profileExcludeFields, ...academicExclude];

  useEffect(() => {
    fetchDepartmentTypes();
  }, []);

  const fetchDepartmentTypes = async () => {
    try {
      const res = await apiClient({
        url: API_ENDPOINTS.GET_DEPARTMENT_TYPES,
        method: "get",
        withAuth: true,
      });

      setDepartmentTypeList(
        res.data?.departments?.map((item) => ({
          label: item.name,
          value: item.id,
          key: item.value,
        }))
      );
    } catch (error) {
      console.error("Department Types fetch error", error);
    }
  };
  useEffect(() => {
    if (!departmentTypeList.length || !userProfile?.department) return;

    const departmentOption = departmentTypeList.find(
      (dep) => dep.key === userProfile.department
    );

    if (departmentOption) {
      reset((prev) => ({
        ...prev,
        department: departmentOption.value,
      }));
    }
  }, [departmentTypeList, userProfile]);

  const selectedDepartment = watch("department");

  useEffect(() => {
    if (selectedDepartment) {
      fetchInstitutionTypes(selectedDepartment);
    } else {
      setDepartmentList([]);
    }
  }, [selectedDepartment]);

  const fetchInstitutionTypes = async (departmentId) => {
    try {
      const res = await apiClient({
        url: `${API_ENDPOINTS.GET_DEPARTMENT_FACULTY}/${departmentId}`,
        method: "get",
        withAuth: true,
      });

      setDepartmentList(
        res.data?.departments?.map((item) => ({
          label: item.name,
          value: item.id,
        }))
      );
    } catch (error) {
      console.error("Institution Type fetch error", error);
    }
  };

  useEffect(() => {
    if (!departmentList.length || !userProfile?.institutionType) return;

    const typeOption = departmentList.find(
      (t) => t.label === userProfile.institutionType
    );

    if (typeOption) {
      reset((prev) => ({
        ...prev,
        institutionType: typeOption.value,
      }));
    }
  }, [departmentList, userProfile]);

  return (
    <>
      {loading && <Loader fullscreen={true} />}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <div className={styles.header}>
          <div className={styles.titleWrap}>
            <h1 className={styles.title}>
              <span className={styles.blue}>
                {" "}
                {userdata.role === "mentor"
                  ? "Mentor Membership Registration"
                  : userdata.role === "author"
                    ? "Research Associate Registration"
                    : ""}
              </span>
              <span className={styles.orange}> Form</span>
            </h1>
            <p className={styles.subtitle}>
              Complete the form below to register as an IMPARC member
            </p>
          </div>
        </div>
        <ProfileCompletion
          watch={watch}
          exclude={finalExclude}
          onChange={(value) => setProfileCompletion(value)}
          isEditable={isEditable}
          setIsEdiatble={setIsEdiatble}
        />

        {/* Part 1: Personal Information */}
        <h2 className={styles.sectionTitle}>
          Part 1 <span className={styles.blue}>Personal </span>
          <span className={styles.orange}>Information</span>
        </h2>
        <p className={styles.note}>
          <strong>Note:</strong> Part1 - all fields are mandatory (
          <span className={styles.mandate}>*</span>)
        </p>
        <div className={styles.grid3}>
          <Input
            label="Full Name"
            name="fullName"
            register={register}
            errors={errors}
            validation={{ required: "Full name required" }}
            value={userdata.name}
            disabled={true}
          />
          <Input
            label="Email Address"
            name="email"
            register={register}
            errors={errors}
            validation={{ required: "Email required", pattern: /^\S+@\S+$/ }}
            value={userdata.email}
            disabled={true}
          />
          <Input
            label="Phone Number"
            name="phone"
            register={register}
            errors={errors}
            validation={{ required: "Phone required" }}
            value={userdata.contact_no}
            disabled={true}
          />
          <Input
            label="Date of Birth"
            name="dob"
            type="date"
            register={register}
            errors={errors}
            validation={{ required: "Date of Birth required" }}
            disabled={!isEditable}
          />

          <TopLabelCustomSelectBox
            label="Gender"
            name="gender"
            control={control}
            errors={errors}
            placeholder="Select"
            options={GenderOptions}
            validation={{ required: "Gender is required" }}
            errorMessage={errors.gender?.message}
            disabled={!isEditable}
          />

          <TopLabelCustomSelectBox
            label="Country"
            name="country"
            control={control}
            errors={errors}
            options={countries}
            validation={{ required: "Country is required" }}
            errorMessage={errors.country?.message}
            disabled={!isEditable}
          />

          <TopLabelCustomSelectBox
            label="State"
            name="state"
            control={control}
            errors={errors}
            options={stateList}
            validation={{ required: "State is required" }}
            errorMessage={errors.state?.message}
            disabled={!isEditable}
          />

          <Input
            label="City"
            name="city"
            register={register}
            errors={errors}
            validation={{
              required: "City is required",
            }}
            disabled={!isEditable}
          />
        </div>

        <div className={styles.grid}>
          <Input
            label="Highest Educational Qualification"
            name="highestQualification"
            register={register}
            errors={errors}
            validation={{
              required: "Highest Educational Qualification is required",
            }}
            disabled={!isEditable}
          />

          <Input
            label="Subject / Stream / Discipline"
            name="subjectStream"
            register={register}
            errors={errors}
            validation={{
              required: "Subject / Stream / Discipline is required",
            }}
            disabled={!isEditable}
          />

          <Input
            label="Institution / University / Organization Name"
            name="institutionName"
            register={register}
            errors={errors}
            validation={{
              required:
                "Institution / University / Organization Name is required",
            }}
            disabled={!isEditable}
          />
          <Input
            label="Current Designation"
            name="currentDesignation"
            register={register}
            errors={errors}
            validation={{ required: "Current Designation is required" }}
            disabled={!isEditable}
          />

          <TopLabelCustomSelectBox
            label="Department"
            name="department"
            errors={errors}
            placeholder="Select"
            options={departmentTypeList}
            control={control}
            validation={{
              required: "Department is required",
            }}
            errorMessage={errors.department?.message}
            disabled={!isEditable}
          />
          <TopLabelCustomSelectBox
            label="Department / Faculty"
            name="departmentFaculty"
            errors={errors}
            placeholder={selectedDepartment ? "Select Department" : "Select"}
            options={departmentList}
            control={control}
            validation={{
              required: "Department / Faculty is required",
            }}
            errorMessage={errors.departmentFaculty?.message}
            disabled={!isEditable || !selectedDepartment}
          />

          <TopLabelCustomSelectBox
            label="How did you hear about IMPARC?"
            name="hearAbout"
            control={control}
            errors={errors}
            placeholder="Select"
            options={FindUsOptions}
            validation={{ required: "About IMPARC is required" }}
            errorMessage={errors.hearAbout?.message}
            disabled={!isEditable}
          />
        </div>
        <div>
          <Textarea
            label="Profile Summary"
            name="profileSummary"
            placeholder="Enter your short profile"
            register={register}
            errors={errors}
            disabled={!isEditable}
          />
        </div>
        <div>
          <SocialMediaLinks
            register={register}
            control={control}
            errors={errors}
            disabled={!isEditable}
          />
          <AcademicLinks
            register={register}
            control={control}
            errors={errors}
            disabled={!isEditable}
          />
        </div>
        <div className={styles.grid}>
          <FileUpload
            label="Upload Photograph"
            name="photograph"
            errors={errors}
            allowedTypes={["jpg", "png", "jpeg"]}
            maxSizeMB={5}
            key={`photo-${fileUploadedKey.current}`}
            errorMessage={errors?.photograph?.message}
            register={(field) =>
              register(field, {
                validate: (v) => {
                  if (!userProfile.photograph && (!v || v.length === 0)) {
                    return "Upload Photograph is required";
                  }
                  return true;
                },
              })
            }
            previewUrl={userProfile.photograph}
            disabled={!isEditable}
          />

          <FileUpload
            label="Upload CV / Resume"
            name="resume"
            errors={errors}
            allowedTypes={["pdf", "docx"]}
            maxSizeMB={10}
            key={`resume-${fileUploadedKey.current}`}
            errorMessage={errors?.resume?.message}
            register={(field) =>
              register(field, {
                validate: (v) => {
                  if (!userProfile.resume && (!v || v.length === 0)) {
                    return "Upload CV/Resume is required";
                  }
                  return true;
                },
              })
            }
            previewUrl={userProfile.resume}
            disabled={!isEditable}
          />
        </div>

        {/* Part 2: Academic & Professional Details */}
        <h2 className={styles.sectionTitle}>
          Part 2 <span className={styles.blue}>Academic & </span>
          <span className={styles.orange}>Professional Details</span>
        </h2>
        <div>
          {/* <TopLabelCustomSelectBox
            label=
            name=""
            register={register}
            errors={errors}
            placeholder="Select"
            options={}
            control={control}
          /> */}

          <TopLabelCustomSelectBox
            label="Years of Experience (Research / Academia / Industry)"
            name="experienceYears"
            control={control}
            errors={errors}
            placeholder="Select"
            options={YearsExperience}
            disabled={!isEditable}
          />
        </div>
        <div>
          <Textarea
            label="Education Summary"
            name="educationSummary"
            placeholder="Please enter"
            register={register}
            errors={errors}
            disabled={!isEditable}
          />
        </div>
        <div>
          <EducationalQualification
            register={register}
            control={control}
            errors={errors}
            disabled={!isEditable}
            subjectOptions={departmentTypeList}
          />
        </div>
        <div>
          <Textarea
            label="Working / Professional Summary"
            name="workingSummary"
            placeholder="Please enter"
            register={register}
            errors={errors}
            disabled={!isEditable}
          />
        </div>
        <div>
          <WorkingExperience
            register={register}
            control={control}
            errors={errors}
            disabled={!isEditable}
          />
        </div>
        <div>
          <Achievements
            register={register}
            control={control}
            errors={errors}
            disabled={!isEditable}
          />
        </div>
        {userdata.role === "mentor" ? (
          <div className={styles.borderBox}>
            <ResearchProjects
              register={register}
              control={control}
              errors={errors}
              setValue={setValue}
              subjectExpertiseList={subjectExpertiseList}
              mentorshipOfferedList={mentorshipOfferedList}
              userProfile={userProfile}
              disabled={!isEditable}
            />
          </div>
        ) : userdata.role === "author" ? (
          <div className={styles.borderBox}>
            <div className={styles.grid}>
              <Input
                label="Reserch Area / Field of Intereset"
                name="fieldofIntereset"
                register={register}
                errors={errors}
                disabled={!isEditable}
              />
              <MentorshipSelect
                label="Membership Benefits Intereseted in"
                name="membershipBenefitsInterested"
                options={membershipBenefitsInterested}
                control={control}
                errors={errors}
                fullWidth={true}
                setValue={setValue}
                disabled={!isEditable}
              />
            </div>
            <div>
              <div>Have you published any research papers or books?</div>
              <div className="radio-group">
                <div className={styles.radioOptions}>
                  <label className={styles.radioItem}>
                    <input
                      type="radio"
                      value="yes"
                      {...register("publishedResearch")}
                      disabled={!isEditable}
                    />
                    Yes
                  </label>

                  <label className={styles.radioItem}>
                    <input
                      type="radio"
                      value="no"
                      {...register("publishedResearch")}
                      disabled={!isEditable}
                    />
                    No
                  </label>
                </div>
              </div>
            </div>
          </div>
        ) : null}
        {(published === "yes" || userdata.role === "mentor") && (
          <>
            <h2 className={styles.sectionTitle}>
              Part 3 <span className={styles.blue}>ACADEMIC </span>
              <span className={styles.orange}>ACTIVITES</span>
            </h2>
            <AcademicActivites
              register={register}
              control={control}
              errors={errors}
              disabled={!isEditable}
            />
          </>
        )}
        <h2 className={styles.sectionTitle}>
          B. <span className={styles.blue}>Workshops / Seminars </span>
          <span className={styles.orange}>
            / Confrences / <br /> FDPs Attended
          </span>
        </h2>
        <WorkshopsSeminars
          register={register}
          control={control}
          errors={errors}
          disabled={!isEditable}
        />

        {/* Declaration */}
        <div className={styles.declaration}>
          <h3 className={styles.declarationTitle}>
            <span className={styles.blue}></span>
          </h3>
          <h2 className={styles.sectionTitle}>
            <span className={styles.blue}>DECLARATION</span>
          </h2>
          <label className={styles.checkbox}>
            <input
              type="checkbox"
              {...register("dataConfirm")}
              disabled={!isEditable}
            />
            I confirm that all information provided is accurate.
          </label>
          <label className={styles.checkbox}>
            <input
              type="checkbox"
              {...register("termsConditions")}
              disabled={!isEditable}
            />
            I agree to the IMPARC Membership Terms & Conditions.
          </label>
          <label className={styles.checkbox}>
            <input
              type="checkbox"
              {...register("allowUseData")}
              disabled={!isEditable}
            />
            I allow IMPARC to use my professional details for its verified
            member directory and communications.
          </label>
        </div>

        <div className={styles.actions}>
          {isEditable && (
            <button className={styles.submit} type="submit">
              Update Profile
            </button>
          )}
        </div>
      </form>
    </>
  );
};

export default MembershipRegistration;
